var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Houses({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.625,
    height: 17.331,
    viewBox: "0 0 33.625 17.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1167",
    "data-name": "Groupe 1167",
    transform: "translate(-64.416 -308.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1010",
    "data-name": "Groupe 1010",
    transform: "translate(-200.17 262.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_23",
    "data-name": "Union 23",
    d: "M10.122,16.331v-2.3a2.253,2.253,0,0,0-2.163-2.3,2.248,2.248,0,0,0-2.165,2.3v2.3H0V4.917H15.918V16.331Zm3.209-1.464h1.54V13.261h-1.54Zm-1.813,0h1.534V13.261H11.518Zm-8.72,0H4.332V13.261H2.8Zm-1.826,0H2.509V13.261H.972Zm12.359-1.886h1.54a1.665,1.665,0,0,0-1.54-1.6Zm-1.813,0h1.534v-1.6A1.72,1.72,0,0,0,11.518,12.981Zm-8.72,0H4.332a1.665,1.665,0,0,0-1.534-1.6Zm-1.826,0H2.509v-1.6A1.665,1.665,0,0,0,.972,12.981ZM13.331,9.868h1.54V8.261h-1.54Zm-1.813,0h1.534V8.261H11.518Zm-8.72,0H4.332V8.261H2.8Zm-1.826,0H2.509V8.261H.972ZM13.331,7.982h1.54a1.665,1.665,0,0,0-1.54-1.6Zm-1.813,0h1.534v-1.6A1.719,1.719,0,0,0,11.518,7.982Zm-8.72,0H4.332A1.664,1.664,0,0,0,2.8,6.381Zm-1.826,0H2.509v-1.6A1.664,1.664,0,0,0,.972,7.982ZM0,4.5c9.772-6,6.146-6,15.918,0Z",
    transform: "translate(273.408 47.374)",
    fill: "#a9aaad",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1012",
    "data-name": "Groupe 1012",
    transform: "translate(-74.967 263.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491",
    "data-name": "Trac\\xE9 491",
    d: "M164.123,58.281l1.7-1.528V54.589h.979V55.9l1.744-1.572,4.461,3.949V62.5h-3.231V61.183a1.268,1.268,0,0,0-1.229-1.273h0a1.262,1.262,0,0,0-1.192,1.273V62.5h-3.231Zm2.422,2.563H165.7v.887h.847Zm-1.019-1.064h-.85v.935h.85Zm1.019,0H165.7v.935h.847Zm-1.019,1.064h-.85v.887h.85Z",
    transform: "translate(0)",
    fill: "#d0d0d0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1013",
    "data-name": "Groupe 1013",
    transform: "translate(-99.706 263.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491-2",
    "data-name": "Trac\\xE9 491",
    d: "M164.123,58.281l1.7-1.528V54.589h.979V55.9l1.744-1.571,4.46,3.949V62.5h-3.231V61.182a1.268,1.268,0,0,0-1.229-1.273h0a1.262,1.262,0,0,0-1.192,1.273V62.5h-3.231Zm2.422,2.563H165.7v.887h.847Zm-1.019-1.064h-.85v.935h.85Zm1.019,0H165.7v.935h.847Zm-1.019,1.064h-.85v.887h.85Z",
    transform: "translate(0)",
    fill: "#d0d0d0",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Houses);
export default __webpack_public_path__ + "static/media/3houses.9a7fea66052abcc5aca726664fbbaa39.svg";
export { ForwardRef as ReactComponent };